import angular from "angular";
import ngAnimate from "angular-animate";
import ngSanitize from "angular-sanitize";
import ngTouch from "angular-touch";
import slider from "angularjs-slider";
import uiDatepicker from "angular-ui-bootstrap/src/datepickerPopup";
import uiSelect from "ui-select";

export default angular
  .module("controllers.marketablesSearch", [
    ngAnimate,
    ngSanitize,
    ngTouch,
    uiSelect,
    uiDatepicker,
    slider,
  ])
  .controller("MarketablesSearchController", [
    "segments",
    "tags",
    "platforms",
    "brands",
    function (segments, tags, platforms, brands) {
      const now = new Date();
      this.datepickerFormat = "dd/MM/yyyy";
      this.datepickerOptions = { showWeeks: false };
      this.today = function () {
        this.dtReleaseFrom = now;
        this.dtSaleLimitFrom = now;
      };
      this.today();

      this.segments = segments;
      this.selectedSegments = [];
      this.brands = brands;
      this.selectedBrands = [];
      this.tags = tags;
      this.selectedTags = [];
      this.platforms = platforms;
      this.selectedPlatforms = [];
      this.datepickers = {
        release: {
          from: { opened: false },
          to: { opened: false },
        },
        saleLimit: {
          from: { opened: false },
          to: { opened: false },
        },
      }

      this.setCurrentMonthInDatepickers = (from, to) => {
        const now = new Date();
        this[from] = new Date(now.getFullYear(), now.getMonth(), 1);
        this[to] = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      }

      this.setNextMonthInDatepickers = (from, to) => {
        var nextMonth = null;
        if (now.getMonth() == 11) {
          nextMonth = new Date(now.getFullYear() + 1, 0, 1);
        } else {
          nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1);
        }
        this[from] = new Date(nextMonth.getFullYear(), nextMonth.getMonth(), 1);
        this[to] = new Date(nextMonth.getFullYear(), nextMonth.getMonth() + 1, 0);
      }

      this.setPastMonthInDatepickers = (from, to) => {
        var pastMonth = new Date();
        pastMonth.setDate(1);
        pastMonth.setMonth(pastMonth.getMonth() - 1);
        this[from] = new Date(pastMonth.getFullYear(), pastMonth.getMonth(), 1);
        this[to] = new Date(pastMonth.getFullYear(), pastMonth.getMonth() + 1, 0);
      }

      this.openDatepicker = datepicker => {
        datepicker.opened = true;
      }
    },
  ])
  .name;



// WEBPACK FOOTER //
// ./app/web/packs/angular/controllers/marketables-search-controller.js